<div class="ui-g-10 ui-md-10">
  <h2>{{ 'campaign.campaigns' | translate }}</h2>
</div>

<!-- Sezione Bottoni-->
<div class="ui-g-12 text-right">
  <!-- Button Esporta Campagna
  <button
    pButton
    class="k-generic-btn"
    type="button"
    (click)="getR()"
    label="{{ 'campaign.export' | translate }}">
  </button>
  Button Duplica campagna
  <button
    pButton
    class="k-generic-btn"
    type="button"
    (click)="getR()"
    label="{{ 'common.duplicate' | translate }}">
  </button>-->
  <!-- Button Crea Campagna-->
  <button pButton class="k-generic-btn" type="button" (click)="createCampaign()" label="{{ 'common.add' | translate }}">
  </button>
  <!-- Button Risorse Utili-->
  <button pButton class="k-generic-btn" type="button" (click)="openPopUpResources()"
    label="{{ 'campaign.resources' | translate }}">
  </button>
</div>

<!-- Tabella Campagne-->
<div class="ui-g-12">
  <app-kontable #table data-testid="table" title="{{ 'campaign.campaigns' | translate }}" [columns]="[
      {field: 'name', title: 'campaign.campaign'},
      {field: 'start_date', title: 'common.date_start', filterType: dateFilter},
      {field: 'end_date', title: 'common.date_end', filterType: dateFilter},
      {field: 'budget', title: 'campaign.step3', filterType: numberFilter}
    ]" [service]="campaign2Service" [paginationType]="paginationType" [showRecoverButton]="false"
    [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
    [showEditButton]="false" [showReport]="false" [additionalRowCommands]="actions">

    <ng-template #actions data-testid="actions" let-row>
      <!-- Button Actions -->
      <p-button pTooltip="{{ 'common.actions' | translate }}" icon="fa fa-location-arrow" styleClass="ui-button-info"
        (click)="openPopUpActions(row.id, row.name)">
      </p-button>

      <!-- Edit relativo al record-->
      <p-button pTooltip="{{ 'common.edit' | translate }}" icon="fa fas fa-edit" styleClass="ui-button-info"
        (onClick)="editCampaign(row.id)">
      </p-button>
    </ng-template>

  </app-kontable>

  <!-- Pop-up di Actions di un record-->
  <p-dialog class="campaign-dialog" [positionTop]="40" [positionLeft]="'50%'" *ngIf="showActionsPopUp"
    [(visible)]="showActionsPopUp" [modal]="true"
    header="{{'common.actions' | translate}} {{'campaign.campaign' | translate}} - {{campaignName}}" [width]="600"
    [draggable]="false" [resizable]="false" (onHide)="closePopUpAction()">
    <app-campaign-action-list
      [campaignId]="campaignId"
      [campaignName]="campaignName"
      [campaignAction]="campaignAction"
      (onCreateCampaignAction)="createCampaignAction()"
      (getCampaignList)="getCampaignList()"
      (onOpenPopUpDuplicateActions)="openPopUpDuplicateActions()"
      (onClosePopUpDuplicateActions)="closePopUpDuplicateAction()"
      (onRefreshCampaignActionList)="refreshCampaignActionList()"
      (onDeleteAction)="deleteAction($event)"
      (onDeployAction)="deployAction($event)"
      (onOpenActionGenerated)="openActionGenerated($event)"
      (onViewAction)="viewAction($event)"
      (onConfirmPreview)="confirmPreview($event)"
      (onConfirmPublish)="confirmPublish($event)"
      (onGenerateCoupon)="generateCoupon($event)"
      (onShowCoupon)="showCoupon($event)">
    </app-campaign-action-list>
  </p-dialog>

  <!-- Popup Risorse Utili -->
  <p-dialog *ngIf="showResources" [(visible)]="showResources" [modal]="true"
    header="{{'campaign.resources' | translate}}" [minWidth]="500" [draggable]="false" [resizable]="false"
    (onHide)="showResources = false;">
    <div class="ui-g-12">
      <a class="link" href="##">Come creare la tua prima campagna</a>
      <br><br>
      <a class="link" href="#">Come scegliere il giusto obiettivo</a>
    </div>
  </p-dialog>

  <!--popup duplicate action-->
  <p-dialog *ngIf="showDuplicateActionsPopUp" [(visible)]="showDuplicateActionsPopUp" [modal]="true"
    header="{{'common.duplicateActions' | translate}} {{campaignName}}" [width]="600" [draggable]="false"
    [resizable]="false" (onHide)="closePopUpDuplicateAction()">
    <app-campaign-action-duplicate-form
      [campaignId]="campaignId"
      (onDuplicateCampaignAction)="duplicateCampaignAction($event)">
    </app-campaign-action-duplicate-form>
  </p-dialog>

  <!-- Popup Campaign Action Generated -->
  <p-dialog class="campaign-dialog" *ngIf="showActionGenerated" [(visible)]="showActionGenerated" [modal]="true"
    header="{{'campaign.campaignAction' | translate}}" [width]="800" [draggable]="false" [resizable]="false"
    (onHide)="closePopUpViewActionGenerated()">
    <app-campaign-action-details
      [viewActionGenerated]="viewActionGenerated"
      [touchPointOfflineList]="touchPointOfflineList"
      [touchPointOnlineList]="touchPointOnlineList"
      [isMessageInstancePresent]="isMessageInstancePresent"
      [isBasketPresent]="isBasketPresent"
      [isCampaignConstraintExclusionPresent]="isCampaignConstraintExclusionPresent"
      [isCampaignConstraintValidationPresent]="isCampaignConstraintValidationPresent"
      [cardHolderType]="cardHolderType"
      [actionStatus]="actionStatus"
      [dynamicCoupon]="dynamicCoupon">
    </app-campaign-action-details>
  </p-dialog>

  <!--popup duplicate action-->
  <p-dialog *ngIf="showMsgInfoDuplicateActionsPopUp" [(visible)]="showMsgInfoDuplicateActionsPopUp" [modal]="true"  [draggable]="false"
    [resizable]="false" (onHide)="closePopUpMsgInfoDuplicateAction()">
    <div class="ui-g-12">
      <p style="color: #d00">{{ 'campaign.duplicateInfoMsg' | translate }}</p>
    </div>
  </p-dialog>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-list2.component.html